import UpdateCategory from "../../../../components/@products/categories/UpdateCategory";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function CategoryUpdatePage() {

    return (
        <UpdateCategory 
            routeType={routeTypes.admin}
        />
    )
}